import React, { Component } from 'react';
import $ from 'jquery';
import { ToastContainer, toast } from "react-toastify";
import "@syncfusion/ej2-base/styles/material.css";
import "@syncfusion/ej2-react-buttons/styles/material.css";
import "@syncfusion/ej2-react-popups/styles/material.css";
import { DialogComponent } from '@syncfusion/ej2-react-popups';

import "react-table-6/react-table.css";
class Review extends Component {
    constructor() {
        super(...arguments);
        this.dialogClose = () => {
            this.state.dispDeletePopup = false;
            this.setState(this.state);
        };
        this.settings = { effect: 'Zoom', duration: 400, delay: 0 };

        //for delete dialog component ok click
        this.buttons = [{
            buttonModel: {
                content: 'Yes',
                cssClass: 'e-flat',
                isPrimary: true,
            },
            'click': props => {
                this.deleteReview(this.state.id)
            }
        }, {
            buttonModel: {
                content: 'No',
                cssClass: 'e-flat',
                isPrimary: true,
            },
            'click': () => {
                this.state.dispDeletePopup = false;
                this.setState(this.state);
            }
        }];

        this.state = {
            appId: '',
            templateProjectId: '',
            id: '',
            dispEditView: false,
            appReviewDataList: [],
            ratings: 0,
            updatedDetails: {},
            updatedRatings: 0,
            updatedRemark: "",
            dispDeletePopup: false,
            disableFullName: true,
            disableEmail: true,
            disableMobileNum: true,
            disableOrgName: true,
            disableAddress: true,
            fields: {},
            errors: {},
            showStore: false,
            enterprise: false,
            stateNameList: [],
            countryNameList: [],
            fields: { countryName: { "name": "", "id": "" }, stateName: { "name": "", "value": "" } },
            showEditBtn: false,
            editable: true,
            loadView: false,
            displayNextBtn: false
        }
    }
    componentDidMount() {
        let thisController = this;
        thisController.fetchAppIdApi();

        document.addEventListener("projectChanged", function (event) {
            thisController.projectId = event.projectId
            thisController.fetchAppIdApi(event.projectId);
        });

    }




    handleChange = (e) => {
        let fields = this.state.fields;
        fields[e.target.name] = e.target.value;
        this.setState({ fields });
    }




    handleChange = (e) => {
        let fields = this.state.fields;
        fields[e.target.name] = e.target.value;
        this.setState({
            fields
        });
    }

    refreshData = (e) => {
        var refController = this;
        e.preventDefault();
        refController.state.errors = {};
        refController.setState(this.state);
        refController.getBillingDetails();
    }


    notifyFailToLoad(response) {
        toast.dismiss();
        toast(<b style={{ color: "red" }}>{response}</b>, {
            position: "top-center",
            color: "red"
        });
    }


    notifyInvalidFields = (message) => {
        toast.dismiss();
        toast(<b> <img src="assets/img/warn.svg"
            style={{ paddingRight: '0px', height: '20px', width: '20px' }}
            content="" /> &nbsp;&nbsp; {message}</b >, {
            position: "top-center"
        });
    }


    notifySuccessToast(response) {
        toast.dismiss();
        toast(<b>
            <img src="./assets/img/done.svg" style={{ paddingRight: '0px' }} content="" />
            &nbsp;&nbsp;{response}</b>, {
            position: "top-center"
        });
    }



    notifyWarning = (message) => {
        toast.dismiss();
        toast(<b><img src="assets/img/warn.svg" alt=""
            style={{ paddingRight: '0px', height: '20px', width: '20px' }} content="" />
            &nbsp;&nbsp;{message}</b>, {
            position: "top-center"
        });
    }
    ratingChanged = (newRating, name) => {
        this.state.ratings = newRating;
        this.setState(this.state);
    }

    ratingUpdated = (updatedRatings, name) => {
        this.state.updatedRatings = updatedRatings;
        this.state.setUpdatedDetails = this.state.updatedDetails;
        this.setState(this.state);

    }

    handleRemark = ({ target }) => {
        this.state.remark = target.value;
        this.setState(this.state);

    }

    handleUpdateRemark = ({ target }) => {
        this.state.updatedRemark = target.value;
        this.setState(this.state);

    }
    fetchAppIdApi(projectId) {
        if (!projectId) {
            projectId = this.projectId;
            if (!projectId) {
                projectId = localStorage.getItem('currentProjectId');
            }
        }
        var localComp = this;
        localComp.state.appReviewDataList = [];
        $.ajax({
            url: "/api/app",
            async: false,
            method: 'GET',
            headers: {
                "Authorization": "Bearer " + localStorage.getItem("access_token")
            },
            data: { templateProjectId: projectId },
            success: function (res) {
                if (res.success === true) {
                    localComp.state.appId = res.result.app.id;
                    localComp.setState(localComp.state);
                    localComp.fetchAppReviewApi();
                }
            },
            error: function (xhr) {
                if (xhr.status === 401) {
                    window.location.href = window.origin + '/login';
                }
            }
        });
    }
    fetchAppReviewApi() {
        var localComp = this;

        $.ajax({
            url: "/api/bot-store/app-review",
            async: false,
            method: 'GET',
            headers: {
                "Authorization": "Bearer " + localStorage.getItem("access_token")
            },
            data: { appId: localComp.state.appId },
            success: function (res) {
                if (res.success === true) {
                    localComp.state.appReviewDataList = res.result;
                    localComp.setState(localComp.state);


                }
            },
            error: function (xhr) {
                if (xhr.status === 401) {
                    window.location.href = window.origin + '/login';
                }
            }
        });
    }
    closeEditView = () => {
        this.state.dispEditView = false;
        this.setState(this.state);
    }

    notifySuccessMsg = (message) => {
        toast.dismiss();
        toast(<b><img src="assets/img/done.svg" style={{ paddingRight: '0px' }} alt=""
            content="" />&nbsp;&nbsp;{message}</b>, {
            position: "top-center"
        });
    }
    notifyError = (response) => {
        toast.dismiss();
        toast(<b><img src="/assets/img/warn.svg"
            style={{ paddingRight: '0px', height: '20px', width: '20px' }} content="" />
            {response}</b>, {
            position: "top-center"
        });
    }
    showDeletePopUp = (id) => {
        this.state.id = id;
        this.state.dispDeletePopup = true;
        this.setState(this.state);
    }

    expandRemark = (e, id) => {
        e.preventDefault();
        var element = document.getElementById("remarkArea" + id);
        var labelEle = document.getElementById("read_more" + id);
        element.style.height = "1px";
        if (labelEle.innerText == "Show less") {
            element.style.height = "60px";
            labelEle.innerText = "...Read More";
        } else {
            element.style.height = (element.scrollHeight) + "px";
            labelEle.innerText = "Show less";
        }
    }
    render() {
        return (
            <div style={{ height: '380px' }}>
                <link href="assets/css/plugins.css" rel="stylesheet" />
                <link href="assets/css/EditDelete.css" rel="stylesheet" />

                <link rel="stylesheet" href="assets/css/reactToastify.css" />
                <link href="assets/css/styles.css" rel="stylesheet" />
                <link href="assets/css/style.css" rel="stylesheet" />

                < ToastContainer className="Toast-at-center" />
                {/* for toaster */}
                <link rel="stylesheet" href="/assets/css/reactToastify.css" />
                <link rel="stylesheet" href="assets/css/material.css" />
                <link rel="stylesheet" href="assets/css/buttonForm.css" />
                {/*for dialog component */}
                <link href="assets/css/ej2-base.css" rel="stylesheet" />
                <link href="assets/css/ej2-react-buttons.css" rel="stylesheet" />
                <link href="assets/css/ej2-react-popups.css" rel="stylesheet" />
                <link href="assets/css/ej2-inputs.css" rel="stylesheet" />
                <link href="assets/css/screenResolution.css" rel="stylesheet" />
                <link rel="shortcut icon" type="image/png" href="assets/img/bot.ico" />



                <div className="_dash_navigation_wraps"  >
                    <div className="container">

                        <div className="row">
                            <div className="col-lg-12 col-md-12 col-sm-12">
                                <div style={{
                                    background: "#F9F9FB", marginLeft: '1%', marginRight: '1%'
                                }}>
                                    <div className="col-sm-12" >
                                        <div className="modal-body">
                                            <div>

                                                <div style={{ display: this.state.appReviewDataList.length != 0 ? 'block' : 'none' }}>
                                                    {this.state.appReviewDataList.map(userBasedReviewData => (
                                                        <div >
                                                            <div className="_rev765" style={{
                                                                marginBottom: '2%', borderRadius: '12px',
                                                                padding: '50px', background: 'white',
                                                                height: 'auto', width: '90%', paddingBottom: '20px'
                                                            }}>

                                                                <div className='row'>
                                                                    <div>

                                                                        <span >{userBasedReviewData.user.fullName}</span>

                                                                    </div>
                                                                    <div >
                                                                        <img title='This batch indicates that this user has purchased this App'
                                                                            className="img-responsive" id="edit-button" align='left'
                                                                            style={{

                                                                                marginTop: '-3px',
                                                                                borderRadius: '5px', padding: '4px',
                                                                                cursor: 'pointer', width: '24px',
                                                                                display: userBasedReviewData.verifiedCustomer == 1 ? 'block' : 'none'
                                                                            }}
                                                                            src="./assets/images/check.png"
                                                                        ></img>
                                                                    </div>
                                                                </div>
                                                                <div className="_ruli9">
                                                                    <h4 className="_re7kl" style={{ marginTop: '0px', marginLeft: '-13px' }}>
                                                                        <span className={userBasedReviewData.appReview.numOfStars >= 4 ? "kjl_4 good" :
                                                                            userBasedReviewData.appReview.numOfStars >= 3 && userBasedReviewData.appReview.numOfStars < 4 ? "kjl_4 min" :
                                                                                userBasedReviewData.appReview.numOfStars >= 2 && userBasedReviewData.appReview.numOfStars < 3 ? "kjl_4 mid" : "kjl_4 poor"}>
                                                                            <i className="fa fa-star" />{userBasedReviewData.appReview.numOfStars}
                                                                        </span>
                                                                    </h4>
                                                                </div>






                                                                <textarea readonly className="htu_98"
                                                                    disabled id={"remarkArea" + userBasedReviewData.appReview.id}
                                                                    value={userBasedReviewData.appReview.remark}
                                                                    style={{
                                                                        marginLeft: '-11px',
                                                                        width: "100%",
                                                                        border: "none",
                                                                        background: "transparent",
                                                                        height: 'auto',
                                                                        color: "#2D4379",
                                                                        fontSize: "15px",
                                                                        textOverflow: "clip",
                                                                        overflow: 'hidden',
                                                                        resize: 'none'
                                                                    }}></textarea>
                                                                <div Align='right' style={{
                                                                    marginTop: '0px',
                                                                    display: (userBasedReviewData.appReview.remark != null &&
                                                                        userBasedReviewData.appReview.remark.length) > 400 ? 'block' : 'none'
                                                                }}>
                                                                    <label className='read_more'

                                                                        id={"read_more" + userBasedReviewData.appReview.id}
                                                                        style={{ color: '#9a9b9b' }}
                                                                        onClick={(e) =>
                                                                            this.expandRemark(e, userBasedReviewData.appReview.id)}
                                                                    >...Read More</label>
                                                                </div>

                                                                <label>On {userBasedReviewData.date}</label>
                                                            </div>
                                                        </div>
                                                    ))}
                                                </div>
                                                <div className="_rev765" Align='center' style={{
                                                    marginTop: '20px', marginLeft: '99px',
                                                    height: '254px', width: '79%',
                                                    display: this.state.appReviewDataList.length == 0 ? 'block' : 'none'
                                                }}>
                                                    <form href='' style={{ height: '200px', background: 'white' }} Align='center'>
                                                        <div style={{ padding: '19px' }} >
                                                            <img src="./assets/images/warn.svg" height="50px" width="50px" />
                                                            <br /><br />
                                                            <label style={{ fontSize: '20px' }}>
                                                                No Reviews & Ratings
                                                            </label><br />

                                                        </div>
                                                    </form>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/*Dialog Component For Deletion Confirmation*/}
                </div>


                {/*Dialog Component For Deletion Confirmation*/}
                <DialogComponent width='400px' style={{ marginTop: '-10%' }} animationSettings={this.settings}
                    header='App Review' showCloseIcon={true} buttons={this.buttons}
                    visible={this.state.dispDeletePopup} close={this.dialogClose}>
                    <img src="/assets/img/warn.svg" style={{ paddingRight: '0px', height: '20px', width: '20px' }}
                        content="" />&nbsp;Do you want to delete the review?<br />Note: Press 'Yes' to delete or press 'No' to decline.
                </DialogComponent>
            </div>

        );
    }
}
export default Review;


// WEBPACK FOOTER //
// ./src/projectmgmt/reports/botStore/Review.js